import { useCallback, useEffect, useState } from 'react';

import { cn } from '@/lib/utils';

import { navigationStore } from '@/store/navigation';

import { NavigationActive } from '@/models/States';

import Button from '../buttons/Button';

interface HamburgerProps extends React.HTMLAttributes<HTMLButtonElement> {
  location: 'header' | 'navigation';
}

export default function Hamburger(props: HamburgerProps) {
  const { location } = props;
  const { className, ...rest } = props;
  const [active, setActive] = useState(false);
  const [init, setInit] = useState(false);
  const toggleNav = navigationStore(
    (store: NavigationActive) => store.toggleNavigation,
  );
  const menuTrigger = useCallback(
    () => setActive((prevActive) => !prevActive),
    [],
  );
  const activeNav = navigationStore(
    (store: NavigationActive) => store.navigation,
  );

  useEffect(() => {
    toggleNav(active);
  }, [active, toggleNav]);

  useEffect(() => {
    setTimeout(() => setActive(activeNav.opened), 150);
  }, [activeNav.opened]);

  useEffect(() => {
    setTimeout(() => setInit(true), 500);
  }, []);

  return (
    <Button
      variant='ghost'
      className={cn(
        'hamburger',
        'z-20 origin-right p-0 transition-transform duration-300 ease-linear',
        'h-6 w-6',
        'relative flex items-center justify-center',
        active && location === 'navigation' && 'active',
        className,
      )}
      onClick={menuTrigger}
      aria-label='Open navigation menu'
      {...rest}
    >
      {location === 'header' && <i></i>}
      <span className={cn('close-wrap', init ? 'opacity-100' : 'opacity-0')}>
        <span className='close-line close-line-1'></span>
        <span className='close-line close-line-2'></span>
      </span>
    </Button>
  );
}
